module.exports = __webpack_public_path__ + "img/logo.507f50d4.png";